import { Box, Chip, IconButton, Typography } from '@mui/material';
import { FileText, X } from '@phosphor-icons/react';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormTabStore } from '../../../../store/storeFormTabs';

export function FormTabs() {
  const navigate = useNavigate();
  const { formId } = useParams();
  const { tabs, setActiveTab, removeFormTabWithNavigation } = useFormTabStore();

  const handleTabClick = (tabFormId: string) => {
    if (tabFormId === formId) return;

    setActiveTab(tabFormId);
    navigate(`/v2/interface/${tabFormId}`);
  };

  const handleCloseTab = (e: React.MouseEvent, tabFormId: string) => {
    e.stopPropagation();
    removeFormTabWithNavigation(tabFormId, navigate);
  };

  if (tabs.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#FFFFFF',
        borderBottom: '1px solid #E5E7EB',
        overflowX: 'auto',
        minHeight: '48px',
        '&::-webkit-scrollbar': {
          height: '4px',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: '#F3F4F6',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#D1D5DB',
          borderRadius: '2px',
        },
      }}
    >
      {tabs.map(tab => (
        <Chip
          key={tab.formId}
          label={
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                maxWidth: '200px',
              }}
            >
              <FileText
                size={16}
                color={tab.isActive ? '#3650DE' : '#6B7280'}
              />
              <Typography
                variant="body2"
                sx={{
                  fontSize: '14px',
                  color: tab.isActive ? '#3650DE' : '#6B7280',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {tab.formName}
              </Typography>
              <IconButton
                size="small"
                onClick={e => handleCloseTab(e, tab.formId)}
                sx={{
                  width: '16px',
                  height: '16px',
                  padding: '0',
                  color: '#6B7280',
                  '&:hover': {
                    color: '#EF4444',
                  },
                }}
              >
                <X size={12} />
              </IconButton>
            </Box>
          }
          onClick={() => handleTabClick(tab.formId)}
          sx={{
            height: '100%',
            backgroundColor: tab.isActive ? '#F9FAFB' : '#FFFFFF',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: '#F9FAFB',
            },
            '& .MuiChip-label': {
              padding: '0 8px',
            },
            borderRadius: '0px',
            borderRight: '1px solid #E5E7EB',
          }}
        />
      ))}
    </Box>
  );
}
